import React from "react";
import { Button } from "react-bootstrap";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Form } from 'react-redux-form';
// Domain
import * as orderDomain from "products/orderHdListings/OrderHdListings";
// Actions \ Action Creators
import * as orderActions from "products/orderHdListings/actions";
//-- Domain UI --------------------------------------------------------------------------------------
// Components
import { FormServerError } from "common/ui/components/forms/FormServerError";
import { TextBox } from "common/ui/components/inputs/TextBox";
const mapStateToProps = (state) => ({
    orderFormState: state.products.orderHdListings.orderFormState
});
const mapDispatchToProps = (dispatch) => ({
    orderActions: bindActionCreators(orderActions, dispatch),
    dispatch: dispatch
});
//-------------------------------------------------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------------------------------------------------
class OrderHdListingsForm extends React.Component {
    //---------------------------------------------------------------------
    handleSubmit(form) {
        // Initialise local variables
        const { orderActions } = this.props;
        // Create Dto
        const dto = { officeId: this.props.officeId, descriptor: form.descriptor, message: form.message };
        // Submit to server
        orderActions.submitRequest(dto);
    }
    //---------------------------------------------------------------------
    render() {
        const { orderFormState } = this.props;
        return (React.createElement(Form, { model: orderDomain.pathsOrderHdListingsForm.modelPath, onSubmit: (form) => this.handleSubmit(form) },
            React.createElement(TextBox, { model: orderDomain.pathsOrderHdListingsForm.descriptor, form: orderFormState, labelText: "Property Address or Listing Reference Number (e.g. T107)", errors: {
                    required: "A Property address or Reference number is required",
                    singlePortalRef: "Please only add a single Listing Reference",
                }, placeHolderText: "Address or Listing Reference...", validators: {
                    required: (val) => val && val.length,
                    singlePortalRef: (val) => {
                        if (val || val.length > 0) {
                            // Regex: 
                            //    Group 1 - Matches a string that starts with a Portal Ref
                            //    Group 2 - Matches first non-digit character after the Portal Ref. 
                            //              If there is something after the the end of the Portal Ref, this is a validation error.
                            // Example: T123, T789
                            // Group1: "T123" 
                            // Group2: ","
                            const emailRegex = /(^(?:[A-Z]|RR)\d+)([^\d])/i;
                            return !emailRegex.test(val);
                        }
                        return true;
                    }
                } }),
            React.createElement(TextBox, { model: orderDomain.pathsOrderHdListingsForm.message, form: orderFormState, type: "textarea", labelText: "Message", errors: {
                    required: "Message is required",
                }, validators: { required: (val) => val && val.length } }),
            React.createElement(FormServerError, { form: orderFormState.$form }),
            React.createElement(Button, { type: "submit", bsStyle: "success", disabled: orderFormState.$form.pending || !orderFormState.$form.valid }, orderFormState.$form.pending ? 'Sending message...' : 'Send message')));
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(OrderHdListingsForm);
